import { render, staticRenderFns } from "./MembersMemberDetails.vue?vue&type=template&id=7115cdce&scoped=true&"
import script from "./MembersMemberDetails.vue?vue&type=script&lang=ts&"
export * from "./MembersMemberDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115cdce",
  null
  
)

export default component.exports